import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractDateInput} from "../abstract-date-input";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPillDateInputComponent),
            multi: true
        }
    ],
    selector: "fui-pill-date-input",
    styleUrls: ["./pill-date-input.component.scss"],
    templateUrl: "./pill-date-input.component.html",
    standalone: false
})
export class FUIPillDateInputComponent extends FUIAbstractDateInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService) {
        super(elementRef, changeDetectorRef, eventsService);
    }
}
